import template from './confirmAddOnModal.html';

class ConfirmAddOnModalController {
    /* @ngInject */
    constructor($uibModal, dataContext, constants, $log, alertService) {
        this.$modal = $uibModal;
        this.$log = $log;
        this.dataContext = dataContext;
        this.constants = constants;
        this.data = this.config.data;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        this.alertService = alertService;
    }

    close() {
        this.$dismiss();
    }

    $onInit() {
        if (this.data.isBundleEnroll) {
            this.isBundleEnroll = true;
            this.bundleName = this.data.bundleName;
            this.bundlePrice = this.data.bundlePrice;
            this.bundle = this.data.bundle;
            this.bundleValueTotal = '15.99';
            this.bundleMonthlyPrice = '10';
            this.bundleCameraCount = '1 camera';
            this.bundleUserCount = '1 user';
            return;
        }
        if (this.data.isBundleRemove) {
            this.isBundleRemove = true;
            this.bundleName = this.data.bundleName;
            this.bundleId = this.data.bundleId;
            return;
        }
        if (this.data.isAIVideoSearchRemove) {
            this.isAIVideoSearchRemove = true;
            return;
        }
        if (this.data.aidAddonServicePlanSelected) {
            this.aidAddon = this.data.aidAddon;
            this.isAIDAddon = true;
            this.isDowngrade = this.data.isDowngrade;
        }
        else {
            this.removeAddOns = this.data.oldQuantity - this.data.newQuantity;
            if (this.removeAddOns > 0) {
                this.isDecreasing = true;
            }
            else {
                this.isDecreasing = false;
                this.newAddOnsCount = this.data.newQuantity - this.data.oldQuantity;
                this.rmr = (this.data.safetyButtonAddOn[0].Price * this.newAddOnsCount).toFixed(2);
            }
        }        
    }

    confirm() {
        this.$close();
        const addOnInfo = {
            OldQuantity: this.data.oldQuantity,
            NewQuantity: this.data.newQuantity,
            addOn: 'Noonlight' // safety button addOn name
        };
        this.dataContext.account.updateAccountAddOns(addOnInfo).then((result) => {
            if (result && result.success) {
                const modalInstance = this.$modal.open({
                    template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                confirm: true
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            }
            if (result && !result.success && result.message) {
                const modalInstance = this.$modal.open({
                    template: '<fp-error-add-on-modal config="config"></fp-error-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                safetyButtonAddOn: this.data.safetyButtonAddOn,
                                oldQuantity: this.data.oldQuantity,
                                newQuantity: this.data.newQuantity,
                                isFeatureRemovedWithInSixMonths: false
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            }
        });
    }

    next() {
        this.$close();
        const modalInstance = this.$modal.open({
            template: '<fp-enrollment-add-on-modal config="config"></fp-enrollment-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        safetyButtonAddOn: this.data.safetyButtonAddOn,
                        oldQuantity: this.data.oldQuantity,
                        newQuantity: this.data.newQuantity
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    nextForAIDAddon() {
        this.$close();
        const modalInstance = this.$modal.open({
            template: '<fp-terms-add-on-modal config="config"></fp-terms-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        aidAddonServicePlanSelected: this.data.aidAddonServicePlanSelected
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    nextForAIDAddonDowngrade() {
        const numberOFCameras = this.data.aidAddonServicePlanSelected.servicePlanName.substring(0, 2).trim();
        const addOnInfo = {
            newQuantity: parseInt(numberOFCameras),
            addOn: 'AIDeterrence', // addOn name to add safety button
            addOnId: this.data.aidAddonServicePlanSelected.addonId
        };
        this.dataContext.account.setAIDAddOns(addOnInfo).then((result) => {
            if (result) {
                const modalInstance = this.$modal.open({
                    template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                isAIDAddon: this.isAIDAddon,
                                isUnenroll: true
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            }
        });
    }

    unenroll() {
        this.$close();
        const numberOFCameras = '0';
        const addOnInfo = {
            newQuantity: parseInt(numberOFCameras),
            addOn: 'AIDeterrence', // addOn name to add safety button
            addOnId: this.data.aidAddonServicePlanSelected.addonId
        };
        this.dataContext.account.setAIDAddOns(addOnInfo).then((result) => {
            if (result) {
                const modalInstance = this.$modal.open({
                    template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                isAIDAddon: true,
                                isUnenroll: true
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            }
        });
        
    }

    nextForBundleEnroll() {
        this.$close();
        const modalInstance = this.$modal.open({
            template: '<fp-terms-add-on-modal config="config"></fp-terms-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        isBundleEnroll: true,
                        bundle: this.bundle
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    unenrollBundle() {
        this.$close();
        this.dataContext.account.removeAddonBundle(this.bundleId).then((result) => {
            if (result && result.success) {
                const modalInstance = this.$modal.open({
                    template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                bundleUnenroll: true,
                                bundleName: this.bundleName
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            } else {
                alert((result && result.message) || 'Error removing bundle.');
            }
        });
    }

    unenrollAIVideoSearch() {
        this.$close();
        this.dataContext.account.removeAIVideoSearchAddOns().then((result) => {
            if (result && result.success) {
                const modalInstance = this.$modal.open({
                    template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                aiVideoSearchUnenroll: true
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            } else {
                alert((result && result.message) || 'Error removing AI Video Search.');
            }
        });
    }
    
}

export default {
    template: template,
    bindings: {
        config: '<',
        safetyButtonAddOn: '<',
        oldQuantity: '<',
        newQuantity: '<',
        aidAddonServicePlanSelected: '<',
        isDowngrade: '<',
        aidAddon: '<',
        isFeatureRemove: '<'
    },
    controller: ConfirmAddOnModalController
};